class ModalCart {
    /**
     * @param {jQuery} $modalCart
     * @constructor
     */
    constructor($modalCart, uiLock) {
        this.$modalCart = $modalCart;
        this.uiLock = uiLock;
        this.$countContainer = $('.header-actions .icon-cart-white');
    }

    /**
     * @param {string} html
     * @returns {ModalCart}
     */
    update(html) {
        'use strict';

        this.$modalCart.html(html);
        return this;
    }

    /**
     * @param {string} html
     * @returns {ModalCart}
     */
    updateIconCount(html) {
        'use strict';

        this.$countContainer.html(html);
        return this;
    }

    /**
     * @param {Number} flashLength
     * @returns {ModalCart}
     */
    flash(flashLength) {
        'use strict';

        this.$modalCart.fadeIn();

        if (flashLength) {
            setTimeout(this.fadeOut.bind(this), flashLength);
        }

        return this;
    }

    fadeOut() {
        'use strict';

        this.$modalCart.fadeOut();
        this.$modalCart.css('display', 'initial');
    }
}

export default ModalCart;